
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor02 as ObiBipolar_transistor02Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-02.js';
 
 
 

 
 export const ObiBipolar_transistor02 = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-02',
   elementClass: ObiBipolar_transistor02Element,
   events: {
     
   }
  });
 
 